import { type Pagination } from "@/types/Pagination";

export const getPaginated =
  <T>(items: T[]) =>
  (limit: number, offset: number): Pagination<T> => ({
    results: items.slice(offset, offset + limit),
    count: items.length,
    next: null,
    previous: null,
  });

export const getNextPageParam =
  (pageLimit: number) =>
  <T>(lastPage?: Pagination<T>, pages: Pagination<T>[] = []) => {
    const totalCount = lastPage?.count ?? 0;
    const nextOffset = pages.length * pageLimit;
    return nextOffset < totalCount ? nextOffset : undefined;
  };
